import { RcClasses } from '../../../foundation';
export var RcDrawerClasses = RcClasses([
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
], 'RcDrawer');
export var drawerRadius = {
    left: [0, 1, 1, 0],
    right: [1, 0, 0, 1],
    top: [0, 0, 1, 1],
    bottom: [1, 1, 0, 0],
};
